import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'indianTimeMoment',
    standalone: true,
})
export class IndianTimeMomentPipe implements PipeTransform {
    transform(value: any): string {
        if (!value) return '';
        return moment(value).subtract(5, 'hours').subtract(30, 'minutes').format('HH:mm');
    }
}